<template>
  <div class="my">
    <img
      src="../../assets/logotable.png"
      style="
        position: fixed;
        top: 0.8rem;
        z-index: 9;
        height: 1.5rem;
        right: 50vw;
      "
    />
    <nav-bar
      :title="'本级审批'"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      class="my-nav"
    />

    <div style="height: 3rem"></div>
    <!-- 上滑进入 -->
    <cell-group title="活动审批">
      <collapse v-model="activeNames">
        <div v-for="(v, i) in list" :key="i">
          <collapse-item :title="v.pro.activityName" :name="i">
            <ant-row>
              <ant-col span="6">
                <div>活动类型:</div>
                <div>人数上限:</div>
                <div>预算金额:</div>
                <div>报名截止:</div>
                <div>开始时间:</div>
                <div>结束时间:</div>
                <div>活动状态:</div>
                <div>报销状态:</div>
              </ant-col>
              <ant-col span="18">
                <div>{{ v.pro.motionGroup }}</div>
                <div>{{ v.pro.numberPeople }}</div>
                <div>{{ v.pro.budget }}</div>
                <div>{{ v.pro.activityFinishTime | ptime }}</div>
                <div>{{ v.pro.activityStartTime | ptime }}</div>
                <div>{{ v.pro.activityEndTime | ptime }}</div>
                <div>{{ v.pro.approveStatus | pstatus }}</div>
                <div>{{ v.pro.budgetResult | pbstatus }}</div>
              </ant-col>
            </ant-row>
            活动内容
            <ant-row>
              <div class="grey-box" style="min-height: auto">
                <div class="ql-container ql-snow">
                  <div
                    class="ql-editor"
                    data-gramm="false"
                    contenteditable="false"
                    v-html="v.pro.activityContent"
                  ></div>
                </div>
              </div>
            </ant-row>
            <grid :column-num="1">
              <grid-item
                icon="photo-o"
                text="活动图片"
                @click="updateImg(v)"
                style="color: #ee0a24"
              />
            </grid>
            <ant-row type="flex" justify="center">
              <ant-button type="info" @click="modify(v)" class="btn"
                >同意</ant-button
              >
              <ant-button @click="modifya(v)" class="btn">不同意</ant-button>
            </ant-row>
          </collapse-item>
        </div>
      </collapse>
      <!-- 分页-->
      <pagination
        v-model="page"
        :total-items="total"
        mode="simple"
        @change="init()"
        v-if="list.length"
      />
      <empty v-else description="暂无数据" />
    </cell-group>

    <!-- 编辑-->
    <popup v-model="show" round position="bottom" :style="{ height: '50%' }">
      <div style="margin: 1rem">
        <ant-form validate-first @submit="onSubmit(1)">
          <div
            style="
              display: flex;
              align-content: center;
              justify-content: space-between;
            " v-show="isshowupapproval && columns.length > 0"
          >
            <div v-show="!btn('three_approval')">
              <span style="color: #646566"> 是否上级审批：</span>
              <van-switch size="18px" v-model="checked" @change="switchChane" />
            </div>
            <div v-show="showSelect" @click="endSelect">确定</div>
          </div>
          <div style="margin-top: 20px" v-show="!showSelect">
            <ant-field
              label="上级审批："
              v-model="userName"
              v-if="checked"
            />
            <ant-field
              label="审批意见："
              v-model="form.vehicleName"
              rows="2"
              autosize
              type="textarea"
              maxlength="50"
              show-word-limit
              placeholder="请输入审批意见"
            />
            <div style="margin: 16px">
              <ant-button
                round
                block
                type="danger"
                native-type="submit"
                :loading="loading"
              >
                提交
              </ant-button>
            </div>
          </div>
          <div v-show="showSelect">
            <picker :columns="columns"
					@change="onupChange"
					value-key="userName" />
          </div>
        </ant-form>
      </div>
    </popup>
    <popup v-model="showa" round position="bottom" :style="{ height: '40%' }">
      <div style="margin: 1rem">
        <ant-form validate-first @submit="onSubmit(2)">
          <ant-field
            label="审批意见："
            v-model="form.vehicleName"
            required
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            show-word-limit
            :rules="[{ required: true, message: '请填写审批意见' }]"
            placeholder="请输入审批意见"
          />
          <div style="margin: 16px">
            <ant-button round block type="danger" native-type="submit">
              提交
            </ant-button>
          </div>
        </ant-form>
      </div>
    </popup>
    <!-- 上滑进入 -->
    <cell-group title="审批历史">
      <collapse v-model="activeNamesB">
        <div v-for="(v, i) in listB" :key="i">
          <collapse-item
            :title="v.pro.activityName ? v.pro.activityName : '-'"
            :name="i"
            v-if="v.pro"
          >
            <ant-row>
              <ant-col span="6">
                <div>活动类型:</div>
                <div>人数上限:</div>
                <div>预算金额:</div>
                <div>报名截止:</div>
                <div>开始时间:</div>
                <div>结束时间:</div>
                <div>活动状态:</div>
                <div>报销状态:</div>
              </ant-col>
              <ant-col span="18">
                <div>{{ v.pro.motionGroup }}</div>
                <div>{{ v.pro.numberPeople }}</div>
                <div>{{ v.pro.budget }}</div>
                <div>{{ v.pro.activityFinishTime | ptime }}</div>
                <div>{{ v.pro.activityStartTime | ptime }}</div>
                <div>{{ v.pro.activityEndTime | ptime }}</div>
                <div>{{ v.pro.approveStatus | pstatus }}</div>
                <div>{{ v.pro.budgetResult | pbstatus }}</div>
              </ant-col>
            </ant-row>
            活动内容
            <ant-row>
              <div class="grey-box" style="min-height: auto">
                <div class="ql-container ql-snow">
                  <div
                    class="ql-editor"
                    data-gramm="false"
                    contenteditable="false"
                    v-html="v.pro.activityContent"
                  ></div>
                </div>
              </div>
            </ant-row>
            <grid :column-num="1">
              <grid-item
                icon="photo-o"
                text="活动图片"
                @click="updateImg(v)"
                style="color: #ee0a24"
              />
            </grid>
            审批意见
            <ant-row>
              {{ v.aprvoceOpinion }}
            </ant-row>
          </collapse-item>
        </div>
      </collapse>
      <!-- 分页-->
      <pagination
        v-model="pageB"
        :total-items="totalB"
        mode="simple"
        @change="init()"
        v-if="listB.length"
      />
      <empty v-else description="暂无数据" />
    </cell-group>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  NavBar,
  Divider,
  Button,
  Form,
  Field,
  DatetimePicker,
  Popup,
  Toast,
  Collapse,
  CollapseItem,
  Col,
  Row,
  Pagination,
  Empty,
  Picker,
  Grid,
  GridItem,
} from "vant";
import service from "../../api/service";
import moment from "moment";
//发布活动
export default {
  name: "approvalActivitiesNoe",
  components: {
    Cell,
    CellGroup,
    NavBar,
    Divider,
    AntButton: Button,
    AntForm: Form,
    AntField: Field,
    DatetimePicker,
    Popup,
    Picker,
    Collapse,
    CollapseItem,
    AntCol: Col,
    AntRow: Row,
    Pagination,
    Empty,
    Grid,
    GridItem,
  },
  data() {
    return {
      loading: false,
      columns: [],
      columnsB: [],
	  isshowupapproval:true,
      userName: "-",
	  upindex:0,
      list: [],
      listB: [],
      page: 1,
      showSelect: false,
      pageB: 1,
      total: 0,
      totalB: 0,
      checked: false,
      activeNames: [],
      activeNamesB: [],
      show: false,
      showa: false,
      select: 0,
      form: {},
      row: {},
      showDate: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    updateImg(v) {
      this.$router.push({
        path: "/updateImg",
        query: { id: v.pro.id, disabled: true },
      });
    },
    init() {
      let form = { ...this.form };
      form.userId = sessionStorage.getItem("id");
      form.page = this.page;
      service
        .get("/api/activity-creation-approval/oexamine", form)
        .then((res) => {
          if (res.status === 200) {
            // this.list = res.data;
			this.list = res.data.filter(function (s) {
			    return s.pro; 
			});
            this.total = res.total;
          }
        });
      service
        .get("/api/activity/queryinvestigateByUser", {
          userId: sessionStorage.getItem("id"),
          page: this.pageB,
        })
        .then((res) => {
          if (res.status === 200) {
            this.listB = res.data;
            this.totalB = res.total;
          }
        });
      service
        .get("/api/activity/queryapprover", {
          deptid: sessionStorage.getItem("deptId"),
        })
        .then((res) => {
          if (res.status === 200) {
            // this.columnsB = res.data;
            // let arr = [];
            // res.data.forEach((v) => {
            //   arr.push(v.userName);
            // });
            // this.columns = arr;
			this.columns = res.data;
			let approvalpersonuserid = this.columns.map(item => {
				return item.id;
			}).join(",");
			if(approvalpersonuserid.indexOf(sessionStorage.getItem("id")) >= 0){
				this.isshowupapproval = false;
			}
          }
        });
    },
    //返回
    onClickLeft() {
      this.$router.push({ path: "/personalCenter" });
    },
	
	onupChange(picker,value, index){
		this.upindex = index;
	},
	
    endSelect() {
      this.nextApprovalNodeApproverId = this.columns[this.upindex];
      if (this.nextApprovalNodeApproverId) {
        this.userName = this.nextApprovalNodeApproverId.userName;
        this.showSelect = false;
      }
    },
    //提交同意
    onSubmit(v) {
      this.show = false;
	  this.showa = false;
      let form = {
        deptId: sessionStorage.getItem("deptId"),
        aproveUserId: sessionStorage.getItem("id"),
        action: this.checked ? 1 : 0,
        flowId: this.row.pro.approveFlowId,
        aprvoceOpinion: this.form.vehicleName,
        approveStatus: v,
      };
        if (this.checked)
          form.nextApprovalNodeApproverId = this.nextApprovalNodeApproverId.id;
      this.checked = false;
      this.loading = true;
      service
        .post("/api/activity-creation-approval/oneapproval", form)
        .then((res) => {
          this.loading = false;
          if (res.status === 200) {
            Toast.success(res.message);
            this.init();
          } else {
            Toast.fail(res.message);
          }
        });
    },
    //提交不同意
    onSubmita() {},
    //修改
    modify(row) {
      this.row = row;
      this.show = true;
    },
    modifya(row) {
      this.row = row;
      this.showa = true;
    },
    //选择时间
    confirm(v) {
      this.showDate = false;
      let t = moment(v).format("YYYY-MM-DD HH:mm:ss");
      if (this.select === 0) {
        this.form.activityStartTimeShow = t;
        this.form.activityStartTime = v;
      } else {
        this.form.activityEndTimeShow = t;
        this.form.activityEndTime = v;
      }
    },
    openStartTime(select) {
      this.select = select;
      this.showDate = true;
    },
    cancel() {
      this.showDate = false;
    },
    formatter(v) {
      console.log(v);
    },
    pstatus(v) {
      switch (v) {
        case "0":
          return "未提交";
        case "1":
          return "审批中";
        case "2":
          return "通过";
        case "3":
          return "未通过";
      }
    },
    switchChane(v) {
        this.showSelect = v;
        if (!v) {
          this.nextApprovalNodeApproverId = {};
        }
    },
  },
  filters: {
    pstatus(v) {
      switch (v) {
        case "0":
          return "未提交";
        case "1":
          return "审批中";
        case "2":
          return "通过";
        case "3":
          return "未通过";
      }
    },
    pbstatus(v) {
      switch (v) {
        case "0":
          return "未提交";
        case "1":
          return "审批中";
        case "2":
          return "通过";
        case "3":
          return "未通过";
      }
    },
    ptime(v) {
      return v ? moment(v).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
  },
};
</script>

<style scoped>
.my {
  background-color: #f7f8fa;
  min-height: 100vh;
}

.btn {
  margin: 1rem;
  width: 30%;
}
</style>